import MasterCrudPage from "../../components/MasterCrudPage";
import {
  bankAccountTypeApi,
  locationApi,
  userBankAccountApi,
  userMasterApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

function isType(location, keyword) {
  return String(location.location_type_name || "")
    .toLowerCase()
    .includes(keyword);
}

export default function UserBankAccount() {
  return (
    <MasterCrudPage
      title="User Bank Account"
      description="User bank account details with cancelled cheque and verification."
      idKey="user_bank_account_id"
      api={userBankAccountApi}
      listLabel="user bank accounts"
      loadExtraOptions={async () => {
        const [users, accountTypes, locations] = await Promise.all([
          userMasterApi.list(),
          bankAccountTypeApi.list(),
          locationApi.list(),
        ]);

        const locationOptions = (locations || []).map((location) => ({
          value: location.location_id,
          label: `${location.location_name}${
            location.location_type_name ? ` (${location.location_type_name})` : ""
          }`,
          location_type_name: location.location_type_name,
        }));

        const cities = locationOptions.filter((location) => isType(location, "city"));

        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          accountTypes: (accountTypes || []).map((type) => ({
            value: type.bank_account_type_id,
            label: type.account_type,
          })),
          cities: cities.length ? cities : locationOptions,
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "bank_account_type_id",
          label: "Bank Account Type",
          type: "select",
          required: true,
          optionsKey: "accountTypes",
          placeholder: "Select account type",
        },
        {
          name: "bank_name",
          label: "Bank Name",
          type: "text",
          required: true,
          placeholder: "Bank name",
        },
        {
          name: "branch_address",
          label: "Branch Address",
          type: "textarea",
          placeholder: "Branch address",
        },
        {
          name: "location_id",
          label: "City (Location)",
          type: "select",
          optionsKey: "cities",
          placeholder: "Select city",
        },
        {
          name: "postal_code",
          label: "Postal Code",
          type: "text",
          placeholder: "Postal / PIN code",
        },
        {
          name: "account_number",
          label: "Account Number",
          type: "text",
          required: true,
          placeholder: "Account number",
        },
        {
          name: "ifsc_code",
          label: "IFSC Code",
          type: "text",
          placeholder: "IFSC code",
        },
        {
          name: "cancelled_cheque",
          label: "Upload Copy of Cancelled Cheque",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
        },
        {
          name: "bank_details_verified",
          label: "Bank Details Verified",
          type: "checkbox",
          defaultValue: false,
          checkLabel: "Verified",
        },
        {
          name: "bank_details_verification_by",
          label: "Bank Details Verification By",
          type: "text",
          placeholder: "Verifier name",
        },
        {
          name: "bank_details_verification_date",
          label: "Bank Details Verification Date",
          type: "date",
        },
        {
          name: "bank_details_verification_certificate",
          label: "Bank Details Verification Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
        },
      ]}
      columns={[
        { key: "user_bank_account_id", label: "ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "account_type", label: "Account Type" },
        { key: "bank_name", label: "Bank Name" },
        { key: "location_name", label: "City" },
        { key: "account_number", label: "Account Number" },
        { key: "ifsc_code", label: "IFSC Code" },
        { key: "bank_details_verified", label: "Verified", type: "status" },
        { key: "bank_details_verification_by", label: "Verified By" },
        { key: "bank_details_verification_date", label: "Verified Date" },
      ]}
    />
  );
}
